import {
    type GQLComponentGroupParentGenericFragment,
    type GQLComponentSubGroupGenericFragment,
    type GQLSubGroupDetailSparePartFragment,
} from "@src/graphql.generated";

export const getSelectedComponentGroup = (
    componentGroupList: GQLComponentGroupParentGenericFragment[],
    componentGroupId: string,
): GQLComponentSubGroupGenericFragment | undefined => {
    for (const componentGroup of componentGroupList) {
        if (componentGroup.componentSubGroups) {
            for (const subGroup of componentGroup.componentSubGroups) {
                if (subGroup.componentGroup.id === componentGroupId) {
                    return subGroup;
                }
            }
        }
    }
};

/**
 * sort spareParts by sortOrder
 * if searchTerm is set, spareParts are filtered within articleName and articleNumber
 * @param spareParts: GQLSubGroupDetailSparePartFragment[]
 * @param searchTerm: string
 * @returns GQLSubGroupDetailSparePartFragment[]
 */
export const sortAndFilterSpareParts = (
    spareParts: GQLSubGroupDetailSparePartFragment[],
    searchTerm?: string,
): GQLSubGroupDetailSparePartFragment[] => {
    const filtered =
        searchTerm && searchTerm !== ""
            ? spareParts.slice().filter((sparePart) => {
                  return (
                      (sparePart.article?.name && sparePart.article.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
                      (sparePart.article?.articleNumber && sparePart.article.articleNumber.toLowerCase().includes(searchTerm.toLowerCase()))
                  );
              })
            : spareParts.slice();

    return filtered.sort((a, b) => +a.sortOrder - +b.sortOrder);
};

export const splitTextAndLinks = (text?: string): (string | { text: string; url: string })[] => {
    if (!text) return [];

    // Regular expression to match markdown-style links
    const linkRegex = /\[([^\]]+)]\((https?:\/\/[^\s)]+)\)/g;

    const segments: (string | { text: string; url: string })[] = [];
    let match;
    let lastIndex = 0;

    // Iterate through matches and segments
    while ((match = linkRegex.exec(text)) !== null) {
        // Add plain text before the link
        if (match.index > lastIndex) {
            segments.push(text.substring(lastIndex, match.index));
        }
        // Add link
        segments.push({ text: match[1], url: match[2] });
        // Update lastIndex
        lastIndex = linkRegex.lastIndex;
    }

    // Add any remaining plain text after the last link
    if (lastIndex < text.length) {
        segments.push(text.substring(lastIndex));
    }

    return segments;
};
